// extracted by mini-css-extract-plugin
var _1 = "ExtensionCommentThread-module__animateUploadProgressBarWidth--SpwWR";
var _2 = "ExtensionCommentThread-module__animatedBackground--SxosV";
var _3 = "ExtensionCommentThread-module__authorName--Ctjhy";
var _4 = "ExtensionCommentThread-module__avatar--DfVbo";
var _5 = "ExtensionCommentThread-module__comment--HRT_v";
var _6 = "ExtensionCommentThread-module__commentAvatar--_tGDD";
var _7 = "ExtensionCommentThread-module__commentContent--tZZRz";
var _8 = "ExtensionCommentThread-module__commentMeta--Jc9du";
var _9 = "ExtensionCommentThread-module__container--Y_KQW";
var _a = "ExtensionCommentThread-module__replyButton--GX9Tj";
var _b = "ExtensionCommentThread-module__time--UIpF7";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authorName", _4 as "avatar", _5 as "comment", _6 as "commentAvatar", _7 as "commentContent", _8 as "commentMeta", _9 as "container", _a as "replyButton", _b as "time" }
